import type { AvailableBlockCalendarEvent, CalendarEventType } from '../../../types';

interface Props {
  event: AvailableBlockCalendarEvent;
}
export const AvailableBlockEvent = ({ event }: Props) => {
  return <div data-event-type={'availableBlock' satisfies CalendarEventType}>{event.eventType}</div>;
};
